import { ContactTypeEditPage } from "@/features/contact/pages/ContactTypeEdit";
import { FC } from "react";

type TContactTypeCreateProps = {
  isCompany: boolean;
};

const ContactTypeEdit: FC<TContactTypeCreateProps> = ({ isCompany }) => {
  return <ContactTypeEditPage isCompany={isCompany} />;
};

export default ContactTypeEdit;
